import Swiper, { type Swiper as SwiperType } from "swiper";
import { Navigation, Pagination } from "swiper/modules";

class ImageCarousel {
  swiperElement: HTMLElement;
  swiperInstance: Swiper | null;

  constructor(swiperElement: HTMLElement) {
    this.swiperElement = swiperElement;
    this.swiperInstance = null;
    this.initSwiper();
  }

  initSwiper() {
    this.swiperInstance = new Swiper(this.swiperElement, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 20,
      allowTouchMove: true,
      longSwipes: true,
      longSwipesRatio: 0.2,
      speed: 300,

      navigation: {
        nextEl: this.swiperElement.querySelector(".image-carousel__next") as HTMLButtonElement,
        prevEl: this.swiperElement.querySelector(".image-carousel__prev") as HTMLButtonElement,
      },

      pagination: {
        el: this.swiperElement.querySelector(
          ".swiper-pagination"
        ) as HTMLElement,
        type: "fraction",
        renderFraction: function(currentClass, totalClass) {
          return `
            (<span class="${currentClass}"></span>/<span class="${totalClass}"></span>)
          `;
        }
      },
    });
  }
}

document
  .querySelectorAll<HTMLElement>(".image-carousel__wrapper")
  .forEach((el) => {
    new ImageCarousel(el);
});